import { render } from "./RecentPurchases.vue?vue&type=template&id=48d012eb&scoped=true"
import script from "./RecentPurchases.vue?vue&type=script&lang=js"
export * from "./RecentPurchases.vue?vue&type=script&lang=js"

import "./RecentPurchases.vue?vue&type=style&index=0&id=48d012eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d012eb"]])

export default __exports__